<template>
  <long-query-layout
    :resource-name="resourceName"
    :query-filter="queryFilter"
    :map-query-filter-for-api="mapQueryFilterForApi"
    :apply-query-filter="applyQueryFilter"
    :active-tab.sync="activeTab"
    :customers.sync="customerCollection"
    :excel-properties-handler="excelPropertiesHandler.bind(this)"
    :customer-download-only="true"
    @query-completed="loadData"
    @result-area-size-change="updateTableSize"
    @query-id-change="queryId = $event"
  >
    <!-- -------------------------------------------------------- -->
    <!-- ヘッダのアクション -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:header-actions="slotProps">
      <div>
        <gl-button @click="editReport = true">cut条件</gl-button>
      </div>
      <div style="margin-left: var(--spacing-medium);">
        <gl-switch
          :value="isDetail"
          :disabled="!(slotProps.queryId && activeTab == 'result')"
          @input="toggleDetail"
          >詳細</gl-switch
        >
      </div>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析条件 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:filter>
      <!-- 期間 -->
      <query-filter-element id="term" title="期間" contentWidth="medium">
        <filter-term v-bind.sync="queryFilter.term" :default-week-count="26" />
      </query-filter-element>

      <!-- 商品分類 -->
      <query-filter-element id="item-tapir-md" title="商品分類">
        <gl-select-company :company.sync="queryFilter.item.company" />
        <filter-item v-bind.sync="queryFilter.item" />
      </query-filter-element>

      <!-- 店舗 -->
      <query-filter-element id="store" title="店舗" contentWidth="medium">
        <filter-store v-bind.sync="queryFilter.store" />
      </query-filter-element>

      <!-- 顧客グループ -->
      <!-- TODO Kappa側で顧客選択の実装ができるまで顧客指定はしません -->
      <!-- <query-filter-element id="customer" title="顧客グループ">
        <filter-customer v-bind.sync="queryFilter.customer" />
      </query-filter-element> -->

      <!-- オプション -->
      <query-filter-element id="option-tapir-md" title="オプション">
        <filter-option v-bind.sync="queryFilter.option" />
      </query-filter-element>

      <md-dialog
        :md-active.sync="uploadingItemFile"
        :md-close-on-esc="false"
        :md-click-outside-to-close="false"
      >
        <md-dialog-content>
          <div style="display:flex;align-items:center">
            <spinner :diameter="30" />
            <span style="margin-left:var(--spacing-medium)">
              階層ファイルをアップロードしています...
            </span>
          </div>
        </md-dialog-content>
      </md-dialog>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析結果 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:result>
      <md-tabs>
        <md-tab md-label="明細（商品）">
          <gl-table ref="itemTable" v-bind="resultTable.item" />
        </md-tab>
        <md-tab md-label="サマリ（セグメントF）">
          <gl-table ref="segmentFTable" v-bind="resultTable.segmentF" />
        </md-tab>
        <md-tab md-label="サマリ（セグメントN）">
          <gl-table ref="segmentNTable" v-bind="resultTable.segmentN" />
        </md-tab>
        <md-tab md-label="ダウンロード">
          <div>
            <a
              v-if="dendroImageUrl"
              :href="dendroImageUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              デンドログラム画像
            </a>
            <span v-else-if="noImageReason">{{ noImageReason }}</span>
            <span v-else>ロード中…</span>
          </div>
          <div>
            <a
              v-if="distMatrixUrl"
              :href="distMatrixUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              距離行列表CSV
            </a>
            <span v-else>ロード中…</span>
          </div>
          <div>
            <a
              v-if="distMatrixUrlSjis"
              :href="distMatrixUrlSjis"
              target="_blank"
              rel="noopener noreferrer"
            >
              距離行列表CSV
              (S-JIS版。Excelなどで文字化けする場合はこちらをご利用ください。)
            </a>
            <span v-else>ロード中…</span>
          </div>
        </md-tab>
      </md-tabs>

      <md-dialog
        :md-active.sync="editReport"
        :md-close-on-esc="true"
        :md-click-outside-to-close="true"
      >
        <md-dialog-content>
          <h4>
            絶対採用
          </h4>
          <md-checkbox v-model="abc" value="A">A商品</md-checkbox>
          <md-checkbox v-model="abc" value="B">B商品</md-checkbox>
          <div
            class="input-inline input-inline"
            style="margin-right: var(--spacing-large);"
          >
            <label class="input-inline__label">
              PI値
            </label>
            <md-field class="input-inline__field">
              <!-- TODO 小数点以下の桁数制限 -->
              <md-input v-model.number="pi" type="number" min="0"></md-input>
            </md-field>
            <label class="input-inline__label">
              以上
            </label>
          </div>

          <h4>
            カット
          </h4>
          <div
            class="input-inline input-inline"
            style="margin-right: var(--spacing-large);"
          >
            <md-field class="input-inline__field">
              <md-input v-model.number="cut" type="number" min="0"></md-input>
            </md-field>
            <label class="input-inline__label">
              ％（＝{{ cutItemNum }} SKU）をカット
            </label>
          </div>
          <div>
            <gl-button primary raised @click="reloadItemGrid">
              反映
            </gl-button>
          </div>
        </md-dialog-content>
      </md-dialog>
    </template>
  </long-query-layout>
</template>

<script>
// 分析条件, 分析結果のためのレイアウト
import LongQueryLayout from '@/components/layout/LongQueryLayout.vue'
// 分析条件
import QueryFilterElement from '@/components/QueryFilterElement.vue'
import FilterTerm from '@/components/FilterTerm.vue'
import FilterItem from '@/components/FilterItemTapirMd.vue'
import FilterStore from '@/components/FilterStore.vue'
import FilterOption from '@/components/FilterOptionTapirMd.vue'
// 分析条件モデル
import term from '@/queryfilter/term'
import item from '@/queryfilter/itemTapirMd'
import store from '@/queryfilter/store'
// 分析結果
import GlTable from '@/components/GlTable.vue'
// misc
import Spinner from '@/components/Spinner.vue'

import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'

import { trimAll } from '@/util/string'
import repository from '@/repositories/Repository'
import { searchCellCustomFunction } from '@/util/custom_formatters'

let sizeFixed = false

let hold = false

const ALWAYS_SHOW_ITEM_COLUMNS = [
  'segment_f',
  'segment_n',
  'relation_order',
  'code',
  'name',
  'customer_count',
  'adopt_order_before',
  'adopt_order_after',
  'recommend',
  'amount_composition_ratio',
  'abc',
  'amount_dev_score',
  'amount_m1f1_ratio',
  'amount_m1f1_dev_score',
  'pi',
  'qty_dev_score',
  'qty_m1f1_ratio',
  'qty_m1f1_dev_score',
  'customer_count_composition_ratio',
  'customer_count_dev_score',
  'customer_count_m1f1_ratio',
  'customer_count_m1f1_dev_score',
  'score',
  'qty_composition_ratio',
  'amount_per_qty',
]

const ALWAYS_SHOW_SEGMENT_COLUMNS = [
  'segment_f',
  'segment_n',
  'customer_count',
  'customer_count_ratio',
  'amount_per_qty',
  'sku_count',
  'amount_per_sku',
  // 年代構成比列は動的なので列構成をAPIから取得してから作成
  'customer_count_m1f1_ratio',
]

const customerCountRatioBorderChangeSubject = new Subject()

// 全列共通セル背景色・文字色フォーマッター
function attributes(rowData, cell, value, colName) {
  const bgColors = rowData.attributes ? rowData.attributes.bgColor : {}
  const bgColor = bgColors ? bgColors[colName] : undefined
  if (bgColor) {
    cell.style.backgroundColor = bgColor
  }

  const fgColors = rowData.attributes ? rowData.attributes.fgColor : {}
  const fgColor = fgColors ? fgColors[colName] : undefined
  if (fgColor) {
    cell.style.color = fgColor
  }
}

function toggleDetail(alwaysShowColumns, colModelsRef, isDetail) {
  colModelsRef.forEach(c => {
    if (!alwaysShowColumns.includes(c.colName)) {
      c.hidden = !isDetail
    }
  })
}

export default {
  components: {
    QueryFilterElement,
    FilterTerm,
    FilterItem,
    FilterStore,
    FilterOption,
    LongQueryLayout,
    GlTable,
    Spinner,
  },
  data() {
    return {
      resourceName: 'tapir-md',
      /**
       * 表示タブ（分析条件、分析結果）
       *
       * 表示タブをプログラム側から切り替えたい場合をこれを使います。
       */
      activeTab: undefined,
      /**
       * 現在表示しているクエリID
       */
      queryId: undefined,
      /**
       * 分析条件
       */
      queryFilter: {
        term: { order: 1, ...term.get() },
        item: { order: 2, ...item.get(), summaryKey: 'itemTapirMd' },
        store: { order: 3, ...store.get() },
        option: {
          order: 4,
          summaryKey: 'optionTapirMd',
          tanaNum: 1,
          errors: [],
        },
      },
      /**
       * 分析結果
       */
      resultTable: {
        item: {
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'relation_order',
          sortOrder: 'asc',
          url: undefined,
          width: 0,
          height: 0,
          customFormatter: {
            linkify: (rowData, cell, value, colName) => {
              cell.classList.add('customer-collection-cell')
              cell.setAttribute(
                'data-customer-collection',
                rowData.customer_filter[colName],
              )

              const toggle = e => {
                if (!this.resultTable.item.columns) {
                  throw new Error('Column not found')
                }

                const id = e.target.getAttribute('data-customer-collection')
                let text

                if (colName.startsWith('segment_f')) {
                  text = rowData.segment_f
                } else if (colName.startsWith('segment_n')) {
                  text = rowData.segment_n
                } else if (colName.startsWith('customer_count')) {
                  text = trimAll(rowData.name)
                }

                const customer = { id, text }

                this.$emit('toggle-customer-collection', customer)
              }

              cell.addEventListener('mousedown', e => {
                hold = true
                document.body.classList.add('no-select')
                toggle(e)
              })
              cell.addEventListener('mouseup', () => {
                hold = false
                document.body.classList.remove('no-select')
              })

              cell.addEventListener('mouseenter', e => {
                if (colName.startsWith('segment')) {
                  return
                }
                if (!hold) {
                  return
                }
                toggle(e)
              })
            },
            linkifySearch: searchCellCustomFunction,
          },
        },
        segmentF: {
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'segment_f',
          sortOrder: 'asc',
          url: undefined,
          width: 0,
          height: 0,
          customFormatter: {
            linkify: (rowData, cell, value, colName) => {
              cell.classList.add('customer-collection-cell')
              cell.setAttribute(
                'data-customer-collection',
                rowData.customer_filter[colName],
              )

              const toggle = e => {
                if (!this.resultTable.segmentF.columns) {
                  throw new Error('Column not found')
                }
                // hit the column
                const col = this.resultTable.segmentF.columns.find(
                  c => c.colName === colName,
                )

                const id = e.target.getAttribute('data-customer-collection')
                let text

                if (!colName.startsWith('customer_count_ratio_')) {
                  text = rowData.segment_f
                } else {
                  text = `${rowData.segment_f} - ${col.headerText}`
                }

                const customer = { id, text }

                this.$emit('toggle-customer-collection', customer)
              }

              cell.addEventListener('mousedown', e => {
                hold = true
                document.body.classList.add('no-select')
                toggle(e)
              })
              cell.addEventListener('mouseup', () => {
                hold = false
                document.body.classList.remove('no-select')
              })

              cell.addEventListener('mouseenter', e => {
                if (!hold) {
                  return
                }
                toggle(e)
              })
            },
          },
        },
        segmentN: {
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'segment_n',
          sortOrder: 'asc',
          url: undefined,
          width: 0,
          height: 0,
          customFormatter: {
            // TODO WET
            linkify: (rowData, cell, value, colName) => {
              cell.classList.add('customer-collection-cell')
              cell.setAttribute(
                'data-customer-collection',
                rowData.customer_filter[colName],
              )

              const toggle = e => {
                if (!this.resultTable.segmentN.columns) {
                  throw new Error('Column not found')
                }
                // hit the column
                const col = this.resultTable.segmentN.columns.find(
                  c => c.colName === colName,
                )

                const id = e.target.getAttribute('data-customer-collection')
                let text

                if (!colName.startsWith('customer_count_ratio_')) {
                  text = rowData.segment_n
                } else {
                  text = `${rowData.segment_n} - ${col.headerText}`
                }

                const customer = { id, text }

                this.$emit('toggle-customer-collection', customer)
              }

              cell.addEventListener('mousedown', e => {
                hold = true
                document.body.classList.add('no-select')
                toggle(e)
              })
              cell.addEventListener('mouseup', () => {
                hold = false
                document.body.classList.remove('no-select')
              })

              cell.addEventListener('mouseenter', e => {
                if (!hold) {
                  return
                }
                toggle(e)
              })
            },
          },
        },
      },
      /**
       * 絶対採用のABCランク
       */
      abc: [],
      /**
       * 絶対採用の下限PI値
       */
      pi: 0,
      /**
       * カットの商品数％
       */
      cut: 0,
      /**
       * 結果商品数（カット商品数の算出に使います）
       */
      resultItemsCount: 0,
      /**
       * 絶対採用などの選択中ダイアログ
       */
      editReport: false,
      /**
       * デンドログラム画像URL
       */
      dendroImageUrl: undefined,
      /**
       * デンドログラム画像なし理由
       */
      noImageReason: undefined,
      /**
       * 距離行列表URL
       */
      distMatrixUrl: undefined,
      /**
       * 距離行列表URL（S-JIS版）
       */
      distMatrixUrlSjis: undefined,
      /**
       * 採用順赤フォントボーダーID数構成比
       */
      customerCountRatioBorder: 1,
      /**
       * 階層ファイルアップロード中
       */
      uploadingItemFile: false,
      /**
       * この画面が持つ分析条件を、クエリのペイロードに変換する
       */
      mapQueryFilterForApi: async queryFilter => {
        const option = {
          report: queryFilter.option.report,
          repeat: queryFilter.option.repeat,
          adoptOrder: queryFilter.option.adoptOrder,
        }
        if (queryFilter.option.report === 'order') {
          option.orderValue = queryFilter.option.orderValue
        } else if (queryFilter.option.report === 'customers') {
          option.customerCountValue = queryFilter.option.customerCountValue
        }

        return {
          term: term.mapToApiPayload(queryFilter.term),
          item: item.mapToApiPayload(queryFilter.item),
          store: store.mapToApiPayload(queryFilter.store),
          option,
        }
      },
      /**
       * 渡された分析条件をこの画面の分析条件に反映する
       *
       * 渡される分析条件はこの画面のものとは限らないので、"可能な限り"復元する。
       */
      applyQueryFilter: queryFilter => {
        term.applyPayload(this.queryFilter.term, queryFilter.term)
        const p = item.applyPayload(this.queryFilter.item, queryFilter.item)
        store.applyPayload(this.queryFilter.store, queryFilter.store)
        this.queryFilter.option.report = queryFilter.option.report
        // this.queryFilter.option.orderValue = queryFilter.option.orderValue
        // this.queryFilter.option.customerCountValue =
        //   queryFilter.option.customerCountValue
        // this.queryFilter.option.adoptOrder = queryFilter.option.adoptOrder
        // this.queryFilter.option.repeat = queryFilter.option.repeat

        return [p]
      },
      /**
       * 顧客コレクション
       */
      customerCollection: [],
      /**
       * Excel出力のパラメータ生成
       */
      excelPropertiesHandler() {
        // 現在のグリッドソート情報
        const itemSort = this.$refs.itemTable.getCurrentSort()
        const segFSort = this.$refs.segmentFTable.getCurrentSort()
        const segNSort = this.$refs.segmentNTable.getCurrentSort()

        const params = []

        // 棚x本パターン
        params.push(`tana=${this.queryFilter.option.tanaNum}`)

        return {
          itemSortColumnName: itemSort.name,
          itemSortOrder: itemSort.order,
          segFSortColumnName: segFSort.name,
          segFSortOrder: segFSort.order,
          segNSortColumnName: segNSort.name,
          segNSortOrder: segNSort.order,
          cut: this.cutItemNum,
          pi: this.pi,
          tana: this.queryFilter.option.tanaNum,
          abc: this.abc,
        }
      },
      isDetail: false,
    }
  },
  computed: {
    cutItemNum() {
      return Math.round(this.resultItemsCount * (this.cut / 100))
    },
  },
  methods: {
    async loadData(queryInfo) {
      const queryFilter = this.queryFilter
      const data = JSON.parse(queryInfo.data)

      this.resultItemsCount = data.numRows.item

      const dendrogramImage = data.kappaResult.dendrogram.image
      if (dendrogramImage.url) {
        this.dendroImageUrl = dendrogramImage.url
      } else {
        this.noImageReason = dendrogramImage.no_image_reason
      }

      const distMatrix = data.kappaResult.dendrogram.dist_matrix
      this.distMatrixUrl = distMatrix.url
      this.distMatrixUrlSjis = distMatrix.url_sjis

      const company = queryFilter.item.company

      // APIからColModelを取得
      const colModels = await Promise.all([
        repository.giggle
          .get(
            this.$longQuery.getColModelFetchUrl(
              this.resourceName,
              queryInfo.id,
              `item?company=${company}`,
            ),
          )
          .then(r => r.data),
        repository.giggle
          .get(
            this.$longQuery.getColModelFetchUrl(
              this.resourceName,
              queryInfo.id,
              `segment?company=${company}`,
            ),
          )
          .then(r => r.data),
      ])

      // 全列共通フォーマッター追加（アタッチするのはJavaScript関数でありサーバーサイドからは連携されないので）
      for (const models of colModels) {
        for (const m of models.colModel) {
          m.customFormatter = attributes
        }
      }

      const itemCol = colModels[0]
      const summaryCol = colModels[1]

      // セグメントの年代構成列は動的なので、列構成をAPIから受け取ってから
      // 詳細表示トグル用の列に追加する
      summaryCol.colModel.forEach(c => {
        if (c.colName.startsWith('customer_count_ratio')) {
          ALWAYS_SHOW_SEGMENT_COLUMNS.push(c.colName)
        }
      })

      toggleDetail(ALWAYS_SHOW_ITEM_COLUMNS, itemCol.colModel, this.isDetail)
      toggleDetail(
        ALWAYS_SHOW_SEGMENT_COLUMNS,
        summaryCol.colModel,
        this.isDetail,
      )

      this.resultTable.item.groupHeaders = itemCol.groupHeader
      this.resultTable.item.columns = itemCol.colModel

      this.resultTable.segmentF.groupHeaders = summaryCol.groupHeader
      this.resultTable.segmentF.columns = summaryCol.colModel.map(c => {
        const copy = { ...c }
        if (c.colName === 'segment_n') {
          copy.hidden = true
        }
        return copy
      })

      this.resultTable.segmentN.groupHeaders = summaryCol.groupHeader
      this.resultTable.segmentN.columns = summaryCol.colModel

      // 結果表示テーブルのURL設定
      const itemUrl = await this.composeItemDataUrl()
      const segFUrl = await this.$longQuery.getQueryResultFetchUrl(
        this.resourceName,
        queryInfo.id,
        `segment/f?company=${company}`,
      )
      const segNUrl = await this.$longQuery.getQueryResultFetchUrl(
        this.resourceName,
        queryInfo.id,
        `segment/n?company=${company}`,
      )

      this.resultTable.item.url = itemUrl
      this.resultTable.segmentF.url = segFUrl
      this.resultTable.segmentN.url = segNUrl
    },
    async reloadItemGrid() {
      this.editReport = false
      this.resultTable.item.url = await this.composeItemDataUrl()
    },
    /**
     * 結果表示テーブルのサイズを更新する
     */
    updateTableSize(size) {
      if (sizeFixed) {
        return
      }

      const mergin = 16

      // this.$refs.myMdTabs.$el.style.width = `${size.width + mergin * 2}px`
      // this.$refs.myMdTabs.$el.style.height = `${size.height + mergin * 2}px`

      const w = size.width
      const h = size.height - mergin * 3 // TODO サイズ調整がかなり無理矢理…

      this.resultTable.item.width = w
      this.resultTable.item.height = h

      this.resultTable.segmentF.width = w
      this.resultTable.segmentF.height = h

      this.resultTable.segmentN.width = w
      this.resultTable.segmentN.height = h

      sizeFixed = true
    },
    toggleDetail(value) {
      this.isDetail = value

      this.customerCollection = []

      toggleDetail(
        ALWAYS_SHOW_ITEM_COLUMNS,
        this.resultTable.item.columns,
        value,
      )
      toggleDetail(
        ALWAYS_SHOW_SEGMENT_COLUMNS,
        this.resultTable.segmentF.columns,
        value,
      )
      toggleDetail(
        ALWAYS_SHOW_SEGMENT_COLUMNS,
        this.resultTable.segmentN.columns,
        value,
      )

      this.$refs.itemTable.init()
      this.$refs.segmentFTable.init()
      this.$refs.segmentNTable.init()
    },
    customerCountRatioBorderChange(value) {
      customerCountRatioBorderChangeSubject.next(value)
    },
    /**
     * 商品データ取得URL作成
     */
    async composeItemDataUrl() {
      let urlOption = '?'

      const params = []

      // カット商品数
      params.push(`cut=${this.cutItemNum}`)

      // 絶対採用 ABC
      for (const v of this.abc) {
        params.push(`abc=${v}`)
      }

      // 絶対採用 PI
      params.push(`pi=${this.pi}`)

      // 棚x本パターン
      params.push(`tana=${this.queryFilter.option.tanaNum}`)

      urlOption += params.join('&')

      return await this.$longQuery.getQueryResultFetchUrl(
        this.resourceName,
        this.queryId,
        'item' + urlOption,
      )
    },
  },
  mounted() {
    const subscription = customerCountRatioBorderChangeSubject
      .asObservable()
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
      )
      .subscribe(async () => {
        this.resultTable.item.url = await this.composeItemDataUrl()
      })

    this.$on('hook:beforeDestroy', () => {
      subscription.unsubscribe()
    })

    // MdTabsを配置すると横幅が大きくなる（左サイドバーの分？）なので、
    // 無理矢理横スクロールが出ないようにする。
    // グリッドサイズは別途合わせて調整している。
    document.querySelector('html').style.overflowX = 'hidden'
  },
}
</script>

<style lang="scss" scoped>
.radio-buttons {
  display: flex;

  &.vertical {
    flex-direction: column;
  }
}

.md-tabs {
  // 結果エリア内のタブに分析結果が入る場合、結果エリアからの
  // マージンがspacing-largeあり、タブ内がspacing-mediumある。
  // 少々マージンを取りすぎなので、グリッドまでが通常のspacing-large
  // になるように調整する。
  // node-sassのバージョン（？）のせいなのかコンパイルされたあとのCSSが
  // "calc(var(--spacing-large) - var(--spacing-medium))"となってしまっていたので
  // ひとまず固定値にした。
  // margin: calc(0px - (var(--spacing-large) - var(--spacing-medium)));
  margin: -16px;
}
</style>
